import { format } from "date-fns"

import { useImage } from "@hooks/useImage"
import { useRoutes } from "@hooks/useRoutes"

const useNormaliseArticles = () => {
  const { urlResolver } = useRoutes()
  const { getGatsbyImage } = useImage()

  const normaliseArticle = (article: GatsbyTypes.SanityArticle): NormalisedArticle => {
    return {
      key: article?._id,
      title: article?.title,
      subtitle: article?.subtitle,
      link: urlResolver(article),
      image: getGatsbyImage(article?.image),
      description: article?.description,
      podcastSrc: article?.podcastSrc,
      attributes: {
        ...article?.attributes,
        author: article?.attributes?.author?.name,
        publishedAt: article?.attributes?.publishedAt && format(new Date(article?.attributes?.publishedAt), "dd MMMM yyyy"),
      },
      category: {
        handle: article?.category?.handle?.current,
        title: article?.category?.title,
      },
      content: article?.additionalContent,
    }
  }

  const normaliseArticles = (articles: GatsbyTypes.SanityArticle[]): NormalisedArticle[] =>
    articles?.map(article => normaliseArticle(article))

  return { normaliseArticle, normaliseArticles }
}

export default useNormaliseArticles
